import { gql } from "@apollo/client";

export default gql`
query GetUsersForDemographics($survey_language: String, $trial_type: String, $survey_type: String) {
  users(trial_type: $trial_type, survey_language:$survey_language, survey_type: $survey_type) {
    id
    user_name
    current_tl_or_sme
    tl_sme_lot
    current_former_fao
    fao_rank
    fao_lot
    fao_assignment
    ilr
    ilr_reading
    ilr_listening
    ilr_speaking
    dlpt
    dlpt_reading
    dlpt_listening
    dlpt_speaking
    opi
    opi_reading
    opi_listening
    opi_speaking
    other
    other_string
    other_reading
    other_listening
    other_speaking
    surveys {
      title
      pc_edge
      pc_chrome
      pc_firefox
      pc_other
      mac_safari
      mac_chrome
      mac_firefox
      mac_other
      ios_tablet
      ios_smartphone
      ios_safari
      ios_edge
      ios_chrome
      ios_firefox
      ios_other
      android_tablet
      android_smartphone
      android_edge
      android_chrome
      android_firefox
      android_other
      vpn
    }
  }
}
`